import { PROFILE_DATA } from './constant'
import { MutationTree } from 'vuex'
import { ProfileState } from './types'

export const mutations: MutationTree<ProfileState> = {
  [PROFILE_DATA](state, data: any) {
    state.email = data.email
    state.userID = data.user_id
    state.displayName = data.display_name
    state.profileURL = data.profile_url
    state.activate = data.activate
    state.uniqueID = data.unique_id
    state.allowChangeEmail = data.allow_change_email
    state.providers = data.providers
    state.riskProfile = data.risk_profile
    state.changingEmail = data.changing_email
    state.tel = data.tel
  }
}
